import BaseService from '@/services/BaseService';
import Vue from 'vue';

class PostService extends BaseService {
  static findBySlug(slug) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${this.resource}/slug/${slug}/`)
        .then(response => resolve(response.body))
        .catch(err => reject(new Error(err)));
    });
  }

  static createPost(data) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${this.resource}/${data.mainCategoryId}/categories/`, data)
        .then(response => resolve(response.body))
        .catch(err => reject(new Error(err)));
    });
  }

  static createMany(posts, meta) {
    return new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < posts.length; i += 1) {
        const post = posts[i];
        const data = Object.assign(post, meta);
        data.step = i + 1;
        const createPromise = Vue.http.post(`${this.resource}/`, data);
        promises.push(createPromise);
      }

      Promise.all(promises)
        .then(values => resolve(values))
        .catch(err => reject(new Error(err)));
    });
  }
}

Object.assign(PostService, {
  resource: 'posts',
});

export default PostService;
